import { LatLng } from "leaflet";

export interface MapLocation {
  name: string;
  lat: number;
  lon: number;
}

/**
 * 地図の初期表示で選択可能な駅の一覧
 */
export const INITIAL_MAP_LOCATIONS: MapLocation[] = [
  { name: "札幌駅", lat: 43.06872106199443, lon: 141.35093776870147 },
  { name: "仙台駅", lat: 38.25996787311199, lon: 140.88263325293906 },
  { name: "東京駅", lat: 35.68124580227406, lon: 139.76669536600596 },
  { name: "横浜駅", lat: 35.466084569033946, lon: 139.62247211845533 },
  { name: "名古屋駅", lat: 35.170996548489605, lon: 136.88155482173673 },
  { name: "京都駅", lat: 34.98595189225564, lon: 135.75909247395 },
  { name: "大阪駅", lat: 34.70262649893962, lon: 135.49624027584966 },
  { name: "博多駅", lat: 33.58987047065479, lon: 130.4209741604731 },
];

/**
 * デフォルトの初期表示位置（東京駅）
 */
export const DEFAULT_MAP_LOCATION = INITIAL_MAP_LOCATIONS.find(
  (location) => location.name === "東京駅"
) ?? {
  name: "東京駅",
  lat: 35.68124580227406,
  lon: 139.76669536600596,
};

/**
 * デフォルトの地図表示位置（Leaflet用LatLngオブジェクト）
 */
export const DEFAULT_MAP_LATLNG = new LatLng(
  DEFAULT_MAP_LOCATION.lat,
  DEFAULT_MAP_LOCATION.lon
);

/**
 * 座標から位置を検索する
 * @param lat 緯度
 * @param lon 経度
 * @returns 一致する位置、見つからない場合はundefined
 */
export const findLocationByCoords = (
  lat: number,
  lon: number
): MapLocation | undefined => {
  return INITIAL_MAP_LOCATIONS.find(
    (location) => location.lat === lat && location.lon === lon
  );
};
